// extracted by css-extract-rspack-plugin
export default {"row":"row-B5bEZB","arrow":"arrow-PrhAU3","list":"list-aF396E"};